import React, { useState } from "react";
import {
  Box,
  Card,
  Typography,
  TextField,
  Button,
  Stack,
  Avatar,
  InputAdornment,
  Container,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import DaalchiniLogo from "../../assets/dalchini_logo.png";
import Clock from "../../assets/clock.png"
import userIcon from "../../assets/userIcon.png"
import lock from "../../assets/lock.png"
import unlock from "../../assets/unlock.png"
import cancellock from "../../assets/cancel_lock.png"
import refund_redeem from "../../assets/refund_redeem.png"
import ProductCarousel from "../Auth_Remeed/ProductCarousel.jsx";
import OTPInput from "./Otp";
/***********************************
 Responsive Page Wrapper (NO shadow on mobile)
************************************/
import {IMAGE_BASE_URL} from '../../config.js'

const PageWrapper = ({ children }) => (
  <Box
    sx={{
      minHeight: "100vh",
      background: {
        xs: "#f4f6f8",
        sm: "linear-gradient(135deg, #eef2ff 0%, #fdf2f8 50%, #ecfeff 100%)",
      },
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      p: { xs: 0, sm: 2 },
    }}
  >
    <Container maxWidth="sm" disableGutters>
      <Card
        sx={{
            bgcolor:{ xs: "transparent", sm: "rgba(255,255,255,0.8)" },
            mt:{xs: "-100px", sm: 4},
          borderRadius: { xs: 0, sm: 4 },
          p: { xs: 2, sm: 3, md: 4 },
          boxShadow: { xs: "none", sm: "0 20px 60px rgba(0,0,0,0.08)" },
          border: { xs: "none", sm: "1px solid rgba(255,255,255,0.6)" },
          backdropFilter: { sm: "blur(6px)" },
        }}
      >
        {children}
      </Card>
    </Container>
  </Box>
);

/***********************************
 Header
************************************/

const AppHeader = () => (
  <Box display={"flex"} justifyContent={"start"}      style={{ position:"absolute", top: 20, left: 20 }} >
  <img
    src={DaalchiniLogo}
    alt="Daalchini Logo"
    style={{ height: 40, display: "block",  }}
  />
  </Box>
);

/***********************************
 Horizontal Cards
************************************/




/***********************************
 Login Content
************************************/




const LoginContent = ({digital_orderId,orderData,mobileNo,handleKeyPress,handleChange,isButtonDisabled,handleAuthenticate,isOTPScreen,handleSubmitOtp,setIsOTPScreen}) => {
  console.log("orderData",orderData)
  const [phone, setPhone] = useState("");

  return (
    <>
     
    <Box>
      {/* Header */}
 

      {/* Avatar */}
      <Stack alignItems="center" spacing={1}>
    <img src={userIcon} alt="User Icon" style={{ width: 90, height: 90 }} />

        <Typography fontWeight={700} fontSize={22}>
          Login
        </Typography>

        <Typography fontSize={13} color="text.secondary" textAlign="center">
          Purchased digital cards will be activated after login.
        </Typography>

        <Typography fontSize={12} color="text.secondary">
          Order ID: {digital_orderId}
        </Typography>
      </Stack>

      <ProductCarousel products={orderData} />

      {/* Expiry */}
      <Stack direction="row" spacing={1} justifyContent="center" mt={2}>
        <img src={Clock} style={{width:"20px"}}/>
        <Typography fontSize={13}>Expires in 24hr</Typography>
      </Stack>

{!isOTPScreen&&<Box
  display="flex"
  alignItems="center"
  width="100%"
  my={2}
>
  <Box flex={1} height="1px" bgcolor="#e0e0e0" />

  <Typography
    mx={2}
    color="text.secondary"
    fontSize={16}
  >
    Login
  </Typography>

  <Box flex={1} height="1px" bgcolor="#e0e0e0" />
</Box>}

      {/* Phone */}
 <Box mt={2}>




       {isOTPScreen?<OTPInput handleSubmitOtp={handleSubmitOtp} resendCode={handleAuthenticate} setIsOTPScreen={setIsOTPScreen}/>:<>   
       
       <TextField
             fullWidth
         placeholder="Enter Mobile Number"
         value={mobileNo}
         onKeyPress={handleKeyPress}
         
         onChange={(e) =>{ 
           
        handleChange(e)
 
 
         }}
         inputProps={{ maxLength: 10 }}
        
           sx={{
             mb: 2,
             backgroundColor: "white",
             borderRadius: 1,
             boxShadow: "0 -1px 7px rgb(0 0 0 / 20%)",
             "& .MuiInputBase-input": { paddingLeft: "10px" },
           }}
           InputProps={{
             type: "tel",
             inputMode: "numeric",
             startAdornment: (
               <InputAdornment position="start">
                 <Box
                   component="img"
                   src="https://flagcdn.com/w20/in.png"
                   alt="India"
                   sx={{ width: 24, mr: 1 }}
                 />
                 <Typography variant="body1">+91</Typography>
               </InputAdornment>
             ),
           }}
         /><Button
  onClick={(e)=>{handleAuthenticate(e)}}
  fullWidth
  disabled={isButtonDisabled}   // ✅ important
  sx={{
    mt: 2,
    py: 1.5,
    borderRadius: 3,
    bgcolor: isButtonDisabled ? "#cfcfcf":"#12b981",
    color: "white",
    fontWeight: 700,
    fontSize: 16,
  }}
>
  Login To Claim
</Button></>}

        <Stack direction="row" spacing={1} justifyContent="center" mt={1.5}>
         <img src={refund_redeem} style={{width:"16px"}}/>
          <Typography fontSize={12} color="#16a34a">
            Full Refund If Not Claimed Within Expiry Time
          </Typography>
        </Stack>
      </Box>
 
    </Box>
    </>
  );
};

/***********************************
 Root
************************************/

export default function Auth({orderData,handleKeyPress,mobileNo,handleChange,isButtonDisabled,handleAuthenticate,isOTPScreen,handleSubmitOtp,setIsOTPScreen,digital_orderId}) {
  console.log("orderData",orderData)
  return (
    <>
    
    <PageWrapper>
       <AppHeader  />
      <LoginContent digital_orderId={digital_orderId}  orderData={orderData} mobileNo={mobileNo} handleKeyPress={handleKeyPress}  handleChange={handleChange} isButtonDisabled={isButtonDisabled} handleAuthenticate={handleAuthenticate} isOTPScreen={isOTPScreen} handleSubmitOtp={handleSubmitOtp} setIsOTPScreen={setIsOTPScreen  }/>
    </PageWrapper>
    </>
  );
}
